/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

import {
  ROLES_UPSERT_REQUEST,
  ROLES_UPSERT_REQUEST_SUCCESS,
  ROLES_UPSERT_REQUEST_FAILURE,
  ROLES_FETCH_REQUEST,
  ROLES_FETCH_REQUEST_SUCCESS,
  ROLES_FETCH_REQUEST_FAILURE,
  ROLES_CLEAN_REQUEST,
} from './types';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const roleReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case ROLES_UPSERT_REQUEST:
    case ROLES_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case ROLES_UPSERT_REQUEST_SUCCESS:
    case ROLES_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.limit,
          total: action.data.totalRecords,
          totalPage: action.data.totalRecords
            ? Math.round(action.data.totalRecords / action.data.limit) +
              (Math.abs(action.data.totalRecords / action.data.limit) >
              Math.round(action.data.totalRecords / action.data.limit)
                ? 1
                : 0)
            : 0,
          showSizeChanger: true,
        },
      });

    case ROLES_UPSERT_REQUEST_FAILURE:
    case ROLES_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case ROLES_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};

export default roleReducer;
